import { Reveal } from "./primitives";

const CHAPTERS = [
    {
        n: "01",
        title: "Guaranteed delivery",
        copy: "At-least-once semantics backed by durable queues and idempotency keys. If an endpoint blinks, MDH holds the line — retrying with exponential backoff until your customer confirms.",
    },
    {
        n: "02",
        title: "Zero-latency filtering",
        copy: "Declarative routing rules evaluate at the edge in microseconds. Transform, split, and fan out payloads in flight — before a single byte leaves our network.",
    },
    {
        n: "03",
        title: "Cryptographic trust",
        copy: "Every payload signed with rotating HMAC keys, every connection pinned with mTLS, every destination screened against SSRF. Trust is verified, never assumed.",
    },
    {
        n: "04",
        title: "Developer-first observability",
        copy: "Live-tail any endpoint, replay any event, and hold every route to a per-endpoint SLA. The command center shows what your webhooks are doing — as they do it.",
    },
];

export default function Manifesto() {
    return (
        <section
            id="manifesto"
            data-testid="manifesto-section"
            className="relative mx-auto max-w-7xl px-5 py-24 lg:px-8 lg:py-32"
        >
            <div className="grid gap-12 lg:grid-cols-[0.9fr_1.1fr] lg:gap-20">
                <div>
                    <Reveal>
                        <p className="font-mono text-xs uppercase tracking-[0.3em] text-teal-400/80">
                            The MDH doctrine
                        </p>
                    </Reveal>
                    <Reveal delay={0.1}>
                        <h2 className="font-display mt-5 text-2xl font-bold leading-tight tracking-tight text-slate-100 sm:text-3xl lg:text-4xl">
                            Four engineering
                            <br />
                            doctrines. Zero
                            <br />
                            <span className="text-slate-500">compromises.</span>
                        </h2>
                    </Reveal>
                    <Reveal delay={0.2}>
                        <p className="mt-6 max-w-sm text-sm leading-relaxed text-slate-400">
                            Event delivery is a promise. These are the rules we engineered MDH
                            around — and the contract your integrations inherit.
                        </p>
                    </Reveal>
                </div>

                <div className="grid gap-px overflow-hidden rounded-xl border border-slate-800/80 bg-slate-800/60 sm:grid-cols-2">
                    {CHAPTERS.map((c, i) => (
                        <Reveal
                            key={c.n}
                            delay={i * 0.08}
                            className="group bg-[#0D1420] p-7 transition-colors duration-300 hover:bg-[#111B2B]"
                            data-testid={`manifesto-chapter-${c.n}`}
                        >
                            <div className="font-mono text-xs font-bold uppercase tracking-[0.3em] text-teal-400/70 transition-colors group-hover:text-cyan-300">
                                {c.n}
                            </div>
                            <h3 className="font-display mt-4 text-lg font-bold tracking-tight text-slate-100">
                                {c.title}
                            </h3>
                            <p className="mt-3 text-xs leading-relaxed text-slate-400 sm:text-sm">
                                {c.copy}
                            </p>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
}
